import React from 'react'
import { Field, ErrorMessage } from 'formik'
import TextError from './TextError'

function Select (props) {
  const { label, name, options, ...rest } = props
  return (
    <div className=' mb-3'>
      <label className=' text-black block mb-2' htmlFor={name}>{label}</label>
      <Field as='select' className=' w-full border rounded-lg bg-[#FAFBFC] border-gray-200 p-5' id={name} name={name} {...rest}>
        {options.map(option => {
          return (
            <option key={option.value} value={option.value}>
              {option.key}
            </option>
          )
        })}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  )
}

export default Select
